import PropTypes from "prop-types";
import { Card, Typography, Box } from "@mui/material";

UsersCountSummary.propTypes = {
  color: PropTypes.string,
  icon: PropTypes.string,
  title: PropTypes.string.isRequired,
  total: PropTypes.number.isRequired,
  sx: PropTypes.object,
};

export default function UsersCountSummary({
  title,
  total,
  icon,
  color = "primary",
  sx,
  ...other
}) {
  return (
    <Card
      sx={{
        py: 2,
        px: 2,
        boxShadow: 0,
        textAlign: "center",
        color: (theme) => theme.palette[color].darker,
        bgcolor: (theme) => theme.palette[color].lighter,
        ...sx,
      }}
      {...other}
    >
      <Typography variant="h5">
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
          {icon && (
            <Box
              component="img"
              src={icon}
              sx={{
                width: 18,
                height: 18,
              }}
              alt=""
            />
          )}
          {total}
        </Box>
      </Typography>

      <Typography variant="subtitle4" sx={{ opacity: 0.72, fontSize: "0.875rem", fontWeight: 600 }}>
        {title}
      </Typography>
    </Card>
  );
}
